import AppConfig from "../../config/AppConfig";
import RegionServerManager from "../RegionServerManager";
import ApiService from "../../services/ApiService";
import DefaultService from "../../services/screens/chinesepark/DefaultService";
import StoreManager from "../../redux/";
import EventEmitter from "../EventEmitter";
import ChatClient from "./ChatClient";
import MD5 from "../MD5";
import _ from "lodash";

//const testRoomAddress = 'ws://192.168.0.100:10001';
//const testRoomAddress = 'ws://127.0.0.1:10001';

function getRoomAddress(addr) {
    //return testRoomAddress;
    return addr;
}

function dummyCallback() {
}

function parseUser(user) {
    var user_roles = user.role.split(',');
    user.role = {code: "", name: "", icon: "", level: 99};
    user.roles = user_roles;
    if (this.roles) {
        for (var role of this.roles) {
            if ((user_roles.indexOf(role.code) != -1)) {
                user.role = role;
                break;
            }
        }
    }
    else {
        console.warn("parseUser no roles!!!");
    }

    if (this.userFlags) {
        user.flags = this.userFlags(user);
    }
    else {
        console.warn("parseUser no user flags!!!");
    }
}

function roomAddrToHttp(_addr) {
    var addr = getRoomAddress(_addr).toLowerCase();
    if (addr.startsWith('ws://')) {
        addr = addr.replace('ws://', 'http://');
    }
    else if (addr.startsWith('wss://')) {
        addr = addr.replace('wss://', 'https://');
    }

    if (!addr.endsWith('/')) {
        addr += '/';
    }
    return addr;
}

class RoomClient {
    constructor() {
        this.roomid = 0;
        this.userid = 0;
        this.clientip = null;
        this.uin = 0;
        this.info = {};
        this.roomState = 1; // exp.ROOM_STATE_OWNERLEAVE
        this.pkstate = {
            state: 0,
            selectBookUser: null,
            selectBookTime: 0,
            launchUser: {},
            dialogUsers: [{}, {}, {}, {}, {}, {}],
        };
        this.pkstep = {};
        this.password = null;
        this.rights = [];
        this.agoraToken = null;
        this.client = null;
        this.connectState = 0;
        this.connectError = null;
        this.events = new EventEmitter();
        this.users = new Map();
        this.tmp_users = new Map();
        this.videos = [];
        this.roles = [
            {code: "owner", name: "Room Owner", icon: null, level: 1},
        ];
        this.speaker = {userid: 0, mode: 0, ssuin: 0};
        this.joinTime = null;
        this.stayTime = 0;
    };
    setConnectState = (state, errmsg) => {
        this.connectError = errmsg;
        this.connectState = state;
        this.events.emit("onConnectState", state);
    };
    getUser = (userid) => {
        var user = this.users.get(userid);
        if (user) {
            return user;
        }

        user = this.tmp_users.get(userid);
        if (user) {
            return user;
        }
        return {uin: 0, uid: userid, name: '' + userid, icon: '', flags: 0};
    };
    getMyUser = () => {
        return this.getUser(this.userid);
    };
    isPKStarted = () => {
        if (this.pkstate.state > exp.PK_STATE_READY) {
            return true;
        }

        if (this.pkstate.state === exp.PK_STATE_READY && this.pkstate.cdown >= 0) {
            return true;
        }
        return false;
    };
    getPKPersons = () => {
        if (this.pkstate.subject && this.pkstate.subject.data) {
            return this.pkstate.subject.data.singleUnits[0].dialogPersons;
        }
        return 0;
    };
    getPKUserRole = (userid) => {
        for (let i = 0; i < this.pkstate.dialogUsers.length; ++i) {
            if (this.pkstate.dialogUsers[i].uid === userid) {
                return i;
            }
        }
        return -1;
    };
    getPKMyRole = () => {
        return this.getPKUserRole(this.userid);
    };
    isPKUserLauncher = (userid) => {
        if (this.pkstate.launchUser.uid === userid) {
            return true;
        }
        return false;
    };
    isPKMyLauncher = () => {
        return this.isPKUserLauncher(this.userid);
    };
    isRoomOwner = () => {
        return this.userid === this.info.ownerId;
    };
    isRoomManager = () => {
        return this.getMyUser().isManager;
    };
    closeClient = () => {
        this.forceClose = true;
        if (this.client) {
            this.client.close();
            this._updateVideos();
            delete this.client;
        }
        this.roomid = 0;
        this.userid = 0;
        this.uin = 0;
        this.info = {};
        this.roomState = 1; // exp.ROOM_STATE_OWNERLEAVE
        this.pkstate = {
            state: 0,
            selectBookUser: null,
            selectBookTime: 0,
            launchUser: {},
            dialogUsers: [{}, {}, {}, {}, {}, {}],
        };
        this.pkstep = {};
        this.rights = [];
        this.agoraToken = null;
        this.client = null;
        this.connectState = 0;
        this.connectError = null;
        this.users.clear();
        this.tmp_users.clear();
        this.videos = [];
        this.speaker = {userid: 0, mode: 0, ssuin: 0};
        this.joinTime = null;
        this.stayTime = 0;
    };
    setRoomId = (roomid) => {
        this.roomid = roomid;
        this.forceClose = false;
    };
    setUserId = (userid) => {
        this.userid = userid;
    };
    setClientIP = (clientip) => {
        this.clientip = clientip;
    };
    setPassword = (passwd) => {
        this.password = passwd;
    };
    setApiServer = (server) => {
        this.apiServer = server;
        if (server) {
            if (!this.oldApiServer) {
                this.oldApiServer = server;
            }

            RegionServerManager.instance().setDisabled(true);
            AppConfig.APP_SERVICE_BASE = server;
            ApiService.setBaseURL(AppConfig.APP_SERVICE_BASE);
        }
        else {
            // restore api service
            if (this.oldApiServer) {
                AppConfig.APP_SERVICE_BASE = this.oldApiServer;
                ApiService.setBaseURL(AppConfig.APP_SERVICE_BASE);
                this.oldApiServer = null;
            }
            RegionServerManager.instance().setDisabled(false);
        }
    };
    /*
    Set Api Server again after call load app override apiconfig
     */
    recoverApiServerIfNeeded = () => {
        if (this.apiServer) {
            RegionServerManager.instance().setDisabled(true);
            AppConfig.APP_SERVICE_BASE = this.apiServer;
            ApiService.setBaseURL(AppConfig.APP_SERVICE_BASE);
            return true;
        }

        return false;
    };
    setServer = (host) => {
        if (this.client) {
            this.client.close();
            delete this.client;
        }

        if (this.forceClose)
            return;

        this.client = new ChatClient({
            parseUser: parseUser.bind(this),
            onConnect: this.onConnect.bind(this),
            onConnectError: this.onConnectError.bind(this),
            onDisconnect: this.onDisconnect.bind(this),
            onJoinRoom: this.onJoinRoom.bind(this),
            onJoin: this.onJoin.bind(this),
            onLeave: this.onLeave.bind(this),
            onKickout: this.onKickout.bind(this),
            onUser: this.onUser.bind(this),
            onUsers: this.onUsers.bind(this),
            onRights: this.onRights.bind(this),
            onSpeaker: this.onSpeaker.bind(this),
            onVideo: this.onVideo.bind(this),
            onVideos: this.onVideos.bind(this),
        });
        this.connectState = exp.CONNECTING;

        //host: "ws://127.0.0.1:10003",
        const serverAddress = getRoomAddress(host);
        this.client.connect(serverAddress);
        this.client.socket.on('roominfo', this.onRoomInfo.bind(this));
        this.client.socket.on('roomstate', this.onRoomState.bind(this));
        this.client.socket.on('pkstate', this.onPKState.bind(this));
        this.client.socket.on('pkstep', this.onPKStep.bind(this));
        this.client.socket.on('pkresult', this.onPKResult.bind(this));
        this.client.socket.on('pkuserinfo', this.onPKUserInfo.bind(this));
        this.client.socket.on('notice', this.onNotice.bind(this));
        this.client.socket.on('sysmsg', this.onSysMsg.bind(this));
        this.client.socket.on('chatmsg', this.onChatMsg.bind(this));
        this.client.socket.on('banchat', this.onBanChat.bind(this));
        this.client.socket.on('addblack', this.onAddBlack.bind(this));
        this.client.socket.on('consume', this.onConsume.bind(this));
    };
    userFlags = (user) => {
        var flags = 0;
        if (this.userVideo(user.uid)) {
            flags |= exp.USER_FLAG_UPMIC;
        }
        return flags;
    };
    updateUserFlags = (userid, addflags, rmflags) => {
        var user = this.users.get(userid);
        if (user) {
            var newflags = user.flags | addflags;
            newflags &= ~rmflags;
            if (user.flags !== newflags) {
                var newuser = _.clone(user);
                newuser.flags = newflags;
                this.users.set(userid, newuser);
                this.events.emit("onUpdateUser", newuser);
            }
        }
    };
    userVideo = (userid) => {
        var count = this.videos.length;
        for (var i = 0; i < count; ++i) {
            var video = this.videos[i];
            if (video && video.userid === userid) {
                return video;
            }
        }
        return null;
    };
    hasRights = (name) => {
        return (this.rights.indexOf(name) >= 0);
    };
    setRights = (rights) => {
        this.rights = rights;
        this.events.emit("rights", rights);
    };
    setUin = (uin) => {
        this.uin = uin;
        this.events.emit("uinChanged", uin);
    };
    isSpeaker = () => {
        return (this.speaker.userid !== 0) && (this.speaker.userid === this.userid);
    };
    setAgoraToken = (token) => {
        this.agoraToken = token;
        this.events.emit("agoraToken", token);
    };
    onConnect = (client) => {
        if (this.client !== client) {
            return;
        }

        var store = StoreManager.getStore();
        var authorization = store.getState().session.authorization;
        this.setConnectState(exp.CONNECTED, null);
        var opts = {
            roomid: this.roomid,
            userid: this.userid,
            clientip: this.clientip,
            token: authorization ? authorization.accessToken : '',
            extra: {},
        };
        if (this.password) {
            opts.password = this.password;
        }
        this.client.joinRoom(opts);
    };
    onJoinRoom = (rep, client) => {
        if (this.client !== client) {
            return;
        }

        this.events.emit("joinRoom", rep);
        if (rep.error) {
            this.setRights([]);
            this.setConnectState(exp.JOINERROR, rep.message);
        }
        else {
            this.joinTime = new Date();
            this.stayTime = rep.data.stayTime;
            this.setApiServer(rep.data.apiServer);
            this.setRights(rep.data.rights);
            this.setUin(rep.data.uin);
            this.setAgoraToken(rep.data.agoraToken);
            this.setConnectState(exp.JOINSUCCESS, null);
        }
    };
    onConnectError = (errmsg, client) => {
        if (this.client !== client) {
            return;
        }
        this.events.emit("onConnectError", errmsg);
        this.setConnectState(exp.CONNECTERROR, errmsg);
    };
    onReconnecting = (client) => {
        if (this.client !== client) {
            return;
        }
        this.events.emit("onReconnecting");
    };
    onDisconnect = (client) => {
        if (this.client !== client) {
            return;
        }

        if (this.forceClose) {
            return;
        }

        this.events.emit("onDisconnect");
        this.setConnectState(exp.DISCONNECTED, null);
    };
    onJoin = (user, opts) => {
        this.users.set(user.uid, user);
        this.events.emit("onJoin", user, opts);
    };
    onLeave = (userid, error, opts) => {
        this.tmp_users.set(userid, this.users.get(userid));
        this.users.delete(userid);
        this.events.emit("onLeave", userid, error, opts);
        //this.tmp_users.delete(userid);
        if (userid === this.userid && error === exp.LEAVE_ROOM_REJOIN) {
            this.closeClient();
        }
    };
    onKickout= (info) => {
        this.events.emit("onKickout", info);
        this.closeClient();
    };
    onUser = (info) => {
        var user = this.users.get(info.uid);
        if (user) {
            Object.assign(user, info);
            this.events.emit("onUser", user);
        }
    };
    onUsers = (users, reset, update) => {
        if (reset) {
            this.users.clear();
        }
        for (var i in users) {
            this.users.set(users[i].uid, users[i]);
        }
        this.events.emit("onUsers", users, reset, update);
    };
    onRights = (rights) => {
        this.setRights(rights);
    };
    onSpeaker = (info) => {
        this.speaker = info;
        this.events.emit("onSpeaker", info);
    };
    onVideo = (video) => {
        this.events.emit("onVideo", video);
        this._updateVideos();
    };
    onVideos = (videos, reset) => {
        this.events.emit("onVideos", videos, reset);
        this._updateVideos();
    };
    onRoomInfo = (info) => {
        this.info = info;
        this.events.emit("onRoomInfo", info);
    };
    onRoomState = (state) => {
        this.roomState = state;
        this.events.emit("onRoomState", state);
    };
    onPKState = (state, message) => {
        var oldSubject = this.pkstate.subject;
        this.pkstate = _.clone(state);
        this.pkstep = {
            pkid: this.pkstate.pkid,
            step: this.pkstate.step,
            stepRole: this.pkstate.stepRole,
            prepare: 0,
            dialogIndex: this.pkstate.dialogIndex,
            sentenceIndex: this.pkstate.sentenceIndex,
            duration: 0,
        };
        if (!this.pkstate.subject) {
            // 由于subject数据比较大, 不是每次都更新subject
            this.pkstate.subject = oldSubject;
        }
        this.events.emit("onPKState", this.pkstate, message);
    };
    onPKStep = (step) => {
        this.pkstep = _.clone(step);
        this.events.emit("onPKStep", this.pkstep);
    };
    onPKResult = (result) => {
        this.events.emit("onPKResult", result);
    };
    onPKUserInfo = (info) => {
        var user = this.users.get(info.uid);
        if (user) {
            user.pkBadge = info.pkBadge;
            user.pkLevel = info.pkLevel;
            user.pkStar = info.pkStar;
            this.events.emit("onPKUserInfo", info);
        }
    };
    onNotice = (notice) => {
        this.events.emit("onNotice", notice);
    };
    onSysMsg = (msg) => {
        this.events.emit("onSysMsg", msg);
    };
    onChatMsg = (msg) => {
        this.events.emit("onChatMsg", msg);
    };
    onBanChat = (data) => {
        this.events.emit("onBanChat", data);
    };
    onAddBlack = (data) => {
        this.events.emit("onAddBlack", data);
    };
    onConsume = (data) => {
        this.events.emit("onConsume", data);
    };
    _startVideo = (video) => {
        var v = this.videos[video.index];
        if (v) {
            if (v.flags !== video.flags) {
                v.flags = video.flags;
                this.events.emit("startVideo", video);
            }

            if (v.userid !== video.userid || v.uin !== video.uin) {
                this._stopVideo(video);
                v = null;
            }
        }

        if (!v) {
            console.log("startVideo: " + video.index);
            v = {
                index: video.index,
                userid: video.userid,
                uin: video.uin,
                flags: video.flags,
            };
            this.updateUserFlags(v.userid, exp.USER_FLAG_UPMIC, 0);
            this.videos[video.index] = v;
            this.events.emit("startVideo", video);
        }
        return true;
    };
    _stopVideo = (video) => {
        var v = this.videos[video.index];
        if (!v)
            return false;

        console.log("stopVideo: " + video.index);
        this.updateUserFlags(v.userid, 0, exp.USER_FLAG_UPMIC);
        delete this.videos[video.index];
        this.events.emit("stopVideo", video);
        return true;
    };
    _updateVideo = (video) => {
        if (video.state) {
            this._startVideo(video);
        }
        else {
            this._stopVideo(video);
        }
    };
    _updateVideos = () => {
        var count = this.client.videos.length;
        var oldcount = this.videos.length;
        for (var i = 0; i < count; ++i) {
            this._updateVideo(this.client.videos[i]);
        }
        if (oldcount > count) {
            for (var i = count; i < oldcount; ++i) {
                this._updateVideo({index: i, state: 0});
            }
            this.videos.splice(count, oldcount - count);
        }
        if (oldcount !== count) {
            this.events.emit("videoCount", count);
        }
    };
    roomInfo = (cb) => {
        if (!this.client || !this.client.socket) {
            cb({error: -1, message: 'notInRoom'});
            return;
        }
        this.client.socket.emit('roomInfo', cb);
    };
    updateSetting = (args, cb) => {
        if (!this.client || !this.client.socket) {
            cb({error: -1, message: 'notInRoom'});
            return;
        }
        this.client.socket.emit('updateSetting', args, cb);
    };
    sendChatMsg = (args, cb) => {
        if (!this.client || !this.client.socket) {
            cb({error: -1, message: 'notInRoom'});
            return;
        }
        this.client.socket.emit('sendChatMsg', args, cb);
    };
    kickout = (args, cb) => {
        if (!this.client || !this.client.socket) {
            cb({error: -1, message: 'notInRoom'});
            return;
        }
        this.client.socket.emit('kickout', args, cb);
    };
    banTextChat = (args, cb) => {
        if (!this.client || !this.client.socket) {
            cb({error: -1, message: 'notInRoom'});
            return;
        }
        this.client.socket.emit('banTextChat', args, cb);
    };
    addBlacklist = (args, cb) => {
        if (!this.client || !this.client.socket) {
            cb({error: -1, message: 'notInRoom'});
            return;
        }
        this.client.socket.emit('addBlacklist', args, cb);
    };
    removeBlacklist = (args, cb) => {
        if (!this.client || !this.client.socket) {
            cb({error: -1, message: 'notInRoom'});
            return;
        }
        this.client.socket.emit('removeBlacklist', args, cb);
    };
    clearBlacklist = (cb) => {
        if (!this.client || !this.client.socket) {
            cb({error: -1, message: 'notInRoom'});
            return;
        }
        this.client.socket.emit('clearBlacklist', cb);
    };
    mediaTestToken = (cb) => {
        if (!this.client || !this.client.socket) {
            cb({error: -1, message: 'notInRoom'});
            return;
        }
        this.client.socket.emit('mediaTestToken', cb);
    };
    startMic = (args, cb) => {
        if (!this.client || !this.client.socket) {
            cb({error: -1, message: 'notInRoom'});
            return;
        }
        this.client.socket.emit('startMic', args, cb);
    };
    stopMic = (args, cb) => {
        if (!this.client || !this.client.socket) {
            cb({error: -1, message: 'notInRoom'});
            return;
        }
        this.client.socket.emit('stopMic', args, cb);
    };
    updateMic = (args, cb) => {
        if (!this.client || !this.client.socket) {
            cb({error: -1, message: 'notInRoom'});
            return;
        }
        this.client.socket.emit('updateMic', args, cb);
    };
    launchPK = (args, cb) => {
        if (!this.client || !this.client.socket) {
            cb({error: -1, message: 'notInRoom'});
            return;
        }
        this.client.socket.emit('launchPK', args, cb);
    };
    acceptPK = (args, cb) => {
        if (!this.client || !this.client.socket) {
            cb({error: -1, message: 'notInRoom'});
            return;
        }
        this.client.socket.emit('acceptPK', args, cb);
    };
    startPK = (args, cb) => {
        if (!this.client || !this.client.socket) {
            cb({error: -1, message: 'notInRoom'});
            return;
        }
        this.client.socket.emit('startPK', args, cb);
    };
    nextPKStep = (args, cb) => {
        if (!this.client || !this.client.socket) {
            cb({error: -1, message: 'notInRoom'});
            return;
        }
        this.client.socket.emit('nextPKStep', args, cb);
    };
    updatePKResult = (args, cb) => {
        if (!this.client || !this.client.socket) {
            cb({error: -1, message: 'notInRoom'});
            return;
        }
        this.client.socket.emit('updatePKResult', args, cb);
    };
    cancelPK = (args, cb) => {
        if (!this.client || !this.client.socket) {
            cb({error: -1, message: 'notInRoom'});
            return;
        }
        this.client.socket.emit('cancelPK', args, cb);
    };
    startWhiteboard = (args, cb) => {
        if (!this.client || !this.client.socket) {
            cb({error: -1, message: 'notInRoom'});
            return;
        }
        this.client.socket.emit('startWhiteboard', args, cb);
    };
    stopWhiteboard = (args, cb) => {
        if (!this.client || !this.client.socket) {
            cb({error: -1, message: 'notInRoom'});
            return;
        }
        this.client.socket.emit('stopWhiteboard', args, cb);
    };
    startShareScreen = (args, cb) => {
        if (!this.client || !this.client.socket) {
            cb({error: -1, message: 'notInRoom'});
            return;
        }
        this.client.socket.emit('startShareScreen', args, cb);
    };
    stopShareScreen = (args, cb) => {
        if (!this.client || !this.client.socket) {
            cb({error: -1, message: 'notInRoom'});
            return;
        }
        this.client.socket.emit('stopShareScreen', args, cb);
    };
    getWBRoomToken = (args, cb) => {
        if (!this.client || !this.client.socket) {
            cb({error: -1, message: 'notInRoom'});
            return;
        }
        this.client.socket.emit('getWBRoomToken', args, cb);
    };
    getWBRoomTokenAsync = (args) => {
        return new Promise((resolve, reject) => {
            this.getWBRoomToken(args, (resp) => {
                resolve(resp);
            });
        });
    };
    startSelectBook = (args, cb) => {
        if (!this.client || !this.client.socket) {
            cb({error: -1, message: 'notInRoom'});
            return;
        }
        this.client.socket.emit('startSelectBook', args, cb);
    };
    stopSelectBook = (args, cb) => {
        if (!this.client || !this.client.socket) {
            cb({error: -1, message: 'notInRoom'});
            return;
        }
        this.client.socket.emit('stopSelectBook', args, cb);
    };
    videoUserId = (index) => {
        var v = this.videos[index];
        return v ? v.userid : 0;
    };
    videoUin = (index) => {
        var v = this.videos[index];
        return v ? v.uin : 0;
    };
    videoFlags = (index) => {
        var v = this.videos[index];
        return v ? v.flags : 0;
    };
}

var exp = new RoomClient();

exp.getUserId = function() {
    let store = StoreManager.getStore();
    return store.getState().session.userId;
}

exp.encryptPassword = function(passwd) {
    if (passwd) {
        const salt = '2dc742a0b3';
        return MD5.hex_md5(passwd + salt);
    }
    return passwd
}

exp.getRoomInfo = function(serverAddress, roomId, userId) {
    const httpAddress = roomAddrToHttp(serverAddress);
    var apiUrl = httpAddress + 'getroominfo?roomId=' + roomId;
    if (userId) {
        apiUrl += '&userId=' + userId;
    }
    return new Promise((resolve, reject) => {
        fetch(apiUrl).then((response) => response.json())
            .then((responseData) => {
                if (responseData.message || responseData.Message) {
                    if (responseData.Message &&
                        responseData.Message.indexOf('RoomId is invalid') >= 0)
                    {
                        resolve(null);
                    }
                    else {
                        console.warn('getroominfo error:', responseData);
                        reject(responseData);
                    }
                }
                else {
                    if (responseData.data && responseData.data.roomId) {
                        resolve(responseData.data);
                    }
                    else {
                        resolve(null);
                    }
                }
            })
            .catch((err) => {
                reject(err);
            });
    });
}

exp.useFreeTime = function(serverAddress, roomId) {
    const httpAddress = roomAddrToHttp(serverAddress);
    var apiUrl = httpAddress + 'usefreetime?roomId=' + roomId;
    return new Promise((resolve, reject) => {
        fetch(apiUrl).then((response) => response.json())
            .then((responseData) => {
                resolve(responseData);
            })
            .catch((err) => {
                reject(err);
            });
    });
}

exp.getMyRoom = function() {
    return new Promise((resolve, reject) => {
        DefaultService.getRoomInfo({ownerId: exp.getUserId()}, (response) => {
            var testData = {
                roomId: '853256514486403072',
                roomNo: 10001,
                remainMinutes: 30,
                isVipExpired: 0,
                vipExpiredOn: null,
                isRoomExpired: 0,
                roomExpiredOn: '7/12/2021',
                serverAddress: ''
            };

            if (response.roomId) {
                const myroom = response;
                exp.getRoomInfo(myroom.serverAddress, myroom.roomId).then(resolve).catch(reject);
            }
            else {
                resolve(null);
            }
        }, (error) => {
            reject(error);
        });
    });
}

exp.updateInvitationDate = function(serverAddress, userId) {
    const httpAddress = roomAddrToHttp(serverAddress);
    const apiUrl = httpAddress + 'updateinvitationdate?userId=' + userId;
    fetch(apiUrl).then((response) => response.json())
        .then((responseData) => {
        })
        .catch((err) => {
        });
}

exp.DISCONNECTED = 0;
exp.CONNECTING   = 1;
exp.CONNECTERROR = 2;
exp.CONNECTED    = 3;
exp.JOINERROR    = 4;
exp.JOINSUCCESS  = 5;

exp.USER_FLAG_UPMIC   = 0x00000001;

exp.MIC_AUDIO_NODEV  = 0x00000001;
exp.MIC_VIDEO_NODEV  = 0x00000002;
exp.MIC_AUDIO_NOPERM = 0x00000004;
exp.MIC_VIDEO_NOPERM = 0x00000008;
exp.MIC_AUDIO_CLOSE  = 0x00000010;
exp.MIC_VIDEO_CLOSE  = 0x00000020;
exp.MIC_USER_LEAVE   = 0x00000400;

exp.LEAVE_ROOM_NORMAL  = 0; /* 正常离开房间 */
exp.LEAVE_ROOM_REJOIN  = 1; /* 在其它地方登录 */
exp.LEAVE_ROOM_KICKOUT = 2; /* 被踢出教室 */
exp.LEAVE_ROOM_CLOSED  = 3; /* 房间关闭 */

exp.PK_STATE_INIT  = 0; /* PK初始状态 */
exp.PK_STATE_WAIT  = 1; /* 等待应战 */
exp.PK_STATE_READY = 2; /* ready */
exp.PK_STATE_CDOWN = 3; /* 倒计时 */
exp.PK_STATE_START = 4; /* start */
exp.PK_STATE_FIGHT = 5; /* 正在PK */

exp.ROOM_TYPE_TALK = 1; /* 口语房间 */
exp.ROOM_TYPE_PK = 2;   /* PK房间 */
exp.ROOM_TYPE_EDU = 1;  /* 教学房间(已跟口语合并) */

exp.ROOM_MODE_TALK = 0; /* 聊天模式 */
exp.ROOM_MODE_WHITEBOARD = 1; /* 白板模式 */
exp.ROOM_MODE_SHARESCREEN = 2; /* 屏幕共享 */

exp.ROOM_STATE_INIT = 0; /* 正常状态 */
exp.ROOM_STATE_OWNERLEAVE = 1; /* 房主不在 */

export default exp;
